/* Copyright (c) 2026 Xperi. All Rights Reserved. */

export { default as profilesReducer } from "./profilesSlice";
export {
  loadProfiles,
  loadProfile,
  loadPartnerConfig,
  loadActiveProfileSelectionPreference,
  saveActiveProfileSelectionPreference,
  createProfile,
  updateProfile,
  deleteProfile,
  setSelectedProfile,
  activateProfile,
  setSelectedProfileId,
  setIsProfileSelected,
  setIsProfileSelectionRequired,
  clearProfilesError,
  resetProfilesState,
  channelLineupRefreshed,
  selectChannelLineupRevision,
  selectProfilesResponse,
  selectSelectedProfileResponse,
  selectSelectedProfileId,
  selectProfilesImageHostBaseUrl,
  selectActiveProfileSelection,
  selectIsProfileSelected,
  selectIsLoadingProfiles,
  selectIsLoadingProfile,
  selectIsCreatingProfile,
  selectIsUpdatingProfile,
  selectIsDeletingProfile,
  selectIsProfileSelectionRequired,
  selectHasReachedProfileLimit,
  selectPartnerConfigResponse,
  selectIsLoadingPartnerConfig,
  selectIsSettingSelectedProfile,
  selectProfilesError,
  selectShouldShowCreateProfileOption,
  buildProfileAvatarImageUrl
} from "./profilesSlice";
export type {
  ProfilesState,
  TActivateProfileParams,
  TActivateProfileResult,
  TActiveProfileSelection,
  TLoadProfilesParams,
  TProfileError
} from "./profiles.types";
export type {
  TProfileListResponse,
  TProfileResponse,
  TPartnerConfigResponse
} from "../../model/types";
export { resolveProfileName, sortProfilesForDisplay } from "./profileDisplay";
export {
  PROFILE_ERROR_OPERATIONS,
  buildProfileErrorDialog,
  isProfileError,
  isProfileNotFoundError,
  normalizeProfileError,
  runProfileRequest,
  showProfileErrorDialog
} from "./profileErrorHandling";
export type {
  ProfileErrorOperation,
  TProfileErrorDialogOptions,
  TProfileRequestOptions
} from "./profileErrorHandling";
export {
  PROFILE_SCOPED_FETCHES,
  refreshProfileScopedData,
  runProfileScopedFetches
} from "./profileScopedData";
export type {
  TProfileScopedFetch,
  TProfileScopedFetchContext
} from "./profileScopedData";
